import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "space-y-4 p-4 sm:p-6 lg:p-8"
}
const _hoisted_2 = { class: "text-xl font-semibold text-gray-800" }
const _hoisted_3 = { class: "grid grid-cols-1 gap-4 sm:grid-cols-2" }
const _hoisted_4 = {
  key: 0,
  class: "grid grid-cols-1 gap-4 sm:grid-cols-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiBackButton = _resolveComponent("UiBackButton")!
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!

  return ($setup.call !== null && !$setup.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_UiPageHeader, null, {
          info: _withCtx(() => [
            _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('core.entity.Call')), 1 /* TEXT */)
          ]),
          actions: _withCtx(() => [
            _createVNode(_component_UiBackButton, { fallbackTo: { name: 'CallList' } })
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode($setup["CallDetails"], {
          call: $setup.call,
          "show-view-button": false,
          "show-download-button": ""
        }, null, 8 /* PROPS */, ["call"]),
        _createVNode($setup["CallPlayer"], { call: $setup.call }, null, 8 /* PROPS */, ["call"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode($setup["CallWords"], {
            call: $setup.call,
            participantType: 
                    $setup.call.type === $setup.CallType.INTERNAL
                        ? $setup.CallParticipantType.AgentA
                        : $setup.CallParticipantType.Agent
                
          }, null, 8 /* PROPS */, ["call", "participantType"]),
          _createVNode($setup["CallWords"], {
            call: $setup.call,
            participantType: 
                    $setup.call.type === $setup.CallType.INTERNAL
                        ? $setup.CallParticipantType.AgentB
                        : $setup.CallParticipantType.Client
                
          }, null, 8 /* PROPS */, ["call", "participantType"])
        ]),
        ($setup.call.surveyAnswers !== undefined && $setup.call.surveyAnswers.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode($setup["CallSurvey"], {
                surveyCallAnswer: $setup.call.surveyAnswers,
                survey: $setup.call.survey
              }, null, 8 /* PROPS */, ["surveyCallAnswer", "survey"])
            ]))
          : _createCommentVNode("v-if", true),
        ($setup.chatBotIntegration)
          ? (_openBlock(), _createBlock($setup["CallChatBot"], {
              key: 1,
              call: $setup.call
            }, null, 8 /* PROPS */, ["call"]))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}